export default __webpack_public_path__ + "static/media/Ability_Huntsman.8faa805a.png";